import { AUTHENTICATE_USER } from "../types/authenticate";

export const authenticateUser = () => ({
    type: AUTHENTICATE_USER,
})
